import { type ParameterConfigKey } from '@/types/measurements';

type EnParameterInfoTranslations = {
  parameterInfo: Partial<Record<ParameterConfigKey, string>>;
};

export const enPerceptionParamInfoTranslations: EnParameterInfoTranslations = {
  parameterInfo: {
    walk_score: 'A composite score reflecting overall gait quality.',
    velocity: 'The speed of walking, measured in meters/second.',
    cadence: 'The number of steps taken per minute.',
    double_support: 'The percentage of the gait cycle when both feet are on the ground.',
    stance_asymmetry:
      'The difference in the percent of time during a stride each foot spends on the ground.',
    step_length_asymmetry: 'The difference in length between the right and left steps.',
    stride_length:
      'The distance covered in one full gait cycle (e.g., from left heel strike to the next left heel strike).',
    sts_repetition_count:
      'The time and movement pattern required to rise from a seated position to standing, capturing lower-limb strength, control, and functional performance.',
    tug_duration_seconds:
      'The time it takes to stand up from a chair, walk 3 meters, turn around, walk back, and sit down—reflecting mobility, balance, and functional independence.',
  },
};
